import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api/v1`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status === 401 && !original._retry && !String(original.url).startsWith("/auth/")) {
      original._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(original);
      } catch {
        /* fall through to original error */
      }
    }
    if (status === 403 && String(error.response?.data?.detail || "").startsWith("REAUTH_REQUIRED") && !original._reauth) {
      original._reauth = true;
      const confirmed = await new Promise((resolve) => window.dispatchEvent(new CustomEvent("pf:reauth", { detail: resolve })));
      if (confirmed) return api(original);
    }
    return Promise.reject(error);
  },
);

export const assetUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail.replace(/^REAUTH_REQUIRED: /, "");
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc.filter((l) => l !== "body").join(".") : "";
        return e?.msg ? `${field ? field + ": " : ""}${e.msg}` : JSON.stringify(e);
      })
      .join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export async function uploadImages(files, kind = "card_image", onProgress) {
  const results = [];
  const chunk = 10;
  for (let i = 0; i < files.length; i += chunk) {
    const form = new FormData();
    files.slice(i, i + chunk).forEach((f) => form.append("files", f));
    const { data } = await api.post(`/uploads/images?kind=${kind}`, form);
    results.push(...data.files);
    onProgress?.(Math.min(i + chunk, files.length), files.length);
  }
  return results;
}
